module.exports = __webpack_public_path__ + "static/10-e308f80304b57de9e59698e1b9daa334.jpeg";